import { cutToast } from 'utility/toast';
import { useMutation } from '@apollo/client';
import { ActionMessageModal } from 'common/components/ActionMessageModal';
import { EntityType } from 'common/types/utility';
import React from 'react';

import { HeaderProps } from '..';
import {
  CorporateChartOfAccountDelete,
  CorporateChartOfAccountDeleteVariables,
} from './__generated__/CorporateChartOfAccountDelete';
import CORPORATE_CHART_OF_ACCOUNT_DELETE from './CorporateChartOfAccountDelete.graphql';
import CORPORATE_CHART_OF_ACCOUNTS from 'common/graphql/CorporateChartOfAccounts.graphql';

type DeleteChartsOfAccountsProps = HeaderProps;

export const DeleteChartsOfAccounts: React.FC<DeleteChartsOfAccountsProps> = ({
  isEdit,
  data,
  onClose,
}) => {
  const { id, _rowTimestamp, _isDeletable } = {
    ...data?.corporateChartOfAccount,
  };

  const [deleteCorporateChartOfAccount] = useMutation<
    CorporateChartOfAccountDelete,
    CorporateChartOfAccountDeleteVariables
  >(CORPORATE_CHART_OF_ACCOUNT_DELETE);

  const onConfirm = async () => {
    if (!!id && !!_rowTimestamp) {
      const { errors } = await deleteCorporateChartOfAccount({
        variables: {
          input: {
            entityDelete: [
              {
                id,
                rowTimestamp: _rowTimestamp,
              },
            ],
          },
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: CORPORATE_CHART_OF_ACCOUNTS,
          },
        ],
      });
      if (errors?.length) cutToast.error(errors[0].message);
      else {
        cutToast.success('Record Deleted Successfully');
        onClose();
      }
    }
  };

  if (!isEdit && !_isDeletable) return null;

  return (
    <>
      <ActionMessageModal
        visible={isEdit}
        entityType={EntityType.ChartOfAccount}
        disabled={!_isDeletable}
        onConfirm={onConfirm}
      />
    </>
  );
};
